function wpcf7Loader() {
  const submitSelector = 'button[type="submit"]';
  const loaderContainers = [
    ...document.querySelectorAll(`[data-js-cf7-spinner]`),
  ]
    .map((el) => el.closest('.wpcf7'))
    .filter((n) => n);

  function setLoading(form) {
    const submit = form.querySelector(submitSelector);
    const spinner = form.querySelector('.cf7-spinner');
    const stepbuttons = form.querySelectorAll('[data-js-multistep-goto]');

    submit.setAttribute('disabled', 'disabled');
    [...stepbuttons].forEach((button) =>
      button.setAttribute('disabled', 'disabled'),
    );
    spinner.classList.remove('u-none');
  }

  function unsetLoading(form) {
    const submit = form.querySelector(submitSelector);
    const spinner = form.querySelector('.cf7-spinner');
    const stepbuttons = form.querySelectorAll('[data-js-multistep-goto]');

    submit.removeAttribute('disabled');
    [...stepbuttons].forEach((button) => button.removeAttribute('disabled'));
    spinner.classList.add('u-none');
  }

  if (loaderContainers.length > 0) {
    loaderContainers.forEach((form) => {
      form.addEventListener(
        'wpcf7submit',
        (event) => {
          unsetLoading(event.target);
        },
        false,
      );

      form.querySelector('form').addEventListener(
        'submit',
        (event) => {
          setLoading(event.target);
        },
        false,
      );
    });
  }
}

export function init() {
  wpcf7Loader();
}
